import { render, staticRenderFns } from "./Rating_History.vue?vue&type=template&id=4530d0c2&scoped=true"
import script from "./Rating_History.vue?vue&type=script&lang=js"
export * from "./Rating_History.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4530d0c2",
  null
  
)

export default component.exports